/**
 * @generated SignedSource<<e0d3fcfebed977689361eaa94b417ebe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type AcceptSwapOfferInput = {
  id: string;
};
export type AcceptSwapOfferMutation$variables = {
  input?: AcceptSwapOfferInput | null | undefined;
};
export type AcceptSwapOfferMutation$data = {
  readonly acceptSwapOffer: {
    readonly fiatAmount: PrecisionFloat | null | undefined;
    readonly status: TransactionStatus | null | undefined;
    readonly taxAmount: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type AcceptSwapOfferMutation = {
  response: AcceptSwapOfferMutation$data;
  variables: AcceptSwapOfferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptSwapOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SwapTransaction",
        "kind": "LinkedField",
        "name": "acceptSwapOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptSwapOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SwapTransaction",
        "kind": "LinkedField",
        "name": "acceptSwapOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cb20b97e58db5b5088218ceafcb74c78",
    "id": null,
    "metadata": {},
    "name": "AcceptSwapOfferMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptSwapOfferMutation(\n  $input: AcceptSwapOfferInput\n) {\n  acceptSwapOffer(input: $input) {\n    status\n    fiatAmount\n    taxAmount\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "da5290d74b2f7604b047a22d2a22e267";

export default node;
